import { render, staticRenderFns } from "./visualizarCategoria.vue?vue&type=template&id=3fbbf1e6&scoped=true"
import script from "./visualizarCategoria.vue?vue&type=script&lang=js"
export * from "./visualizarCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbf1e6",
  null
  
)

export default component.exports